class CustomerReferralsAndRewards {

  constructor(userBasePath, apiClient) {

    this.basePath = `${userBasePath}`;
    this.apiClient = apiClient;

  }

  async getReferAndEarnDetailsByStartupUserId(startupCustomerId) {

    const path = `${this.basePath}/refer-and-earn-details`;

    return this.apiClient.get(path, { startupCustomerId, }, {});

  }

  async getPopulatedReferrerRewardsByStartupUserIdAndQueryOptions(startupCustomerId, queryOptions) {

    const path = `${this.basePath}/referrer-rewards`;

    return this.apiClient.get(path, { startupCustomerId, }, queryOptions);

  }

  async settleReferrerRewardById(startupCustomerId, referrerRewardId) {

    const path = `${this.basePath}/referrer-rewards/:referrerRewardId/settle`;

    return this.apiClient.put(path, { startupCustomerId, referrerRewardId }, {}, {});

  }

  async cancelReferrerRewardById(startupCustomerId, referrerRewardId) {

    const path = `${this.basePath}/referrer-rewards/:referrerRewardId/cancel`;

    return this.apiClient.put(path, { startupCustomerId, referrerRewardId }, {}, {});

  }

  async getReferrerRewardSummariesByStartupUserId(startupCustomerId) {

    const path = `${this.basePath}/referrer-reward-summaries`;

    return this.apiClient.get(path, { startupCustomerId, }, {});

  }

}

export default CustomerReferralsAndRewards;